/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDiamond = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M12 22.4 1.6 12 12 1.6 22.4 12zM4.4 12l7.6 7.6 7.6-7.6L12 4.4z" fill="currentcolor" />
  </Icon>
);
export { SvgDiamond as Diamond };
